import React from 'react';
import styled from 'styled-components';

import Anchor from '../Anchor';

import IconShoppingCart from '../../assets/svgs/cart-empty-filled.svg';

const SCCenteredAnchor = styled(Anchor)`
  display: flex;
  align-items: center;
`;

const ShoppingCart = ({ url }) => (
  <SCCenteredAnchor href={url}>
    <IconShoppingCart size={38} />
  </SCCenteredAnchor>
);

export default ShoppingCart;
